import { useQuery } from '@tanstack/react-query';
import { getIndexes } from '../providers/productFinderAPI';
import { queryKeys } from './queryKeys';
import IIndexValue from '../models/iIndexValue';

export const useIndexes = (bearerToken: string, enabled = true) => {
  return useQuery<IIndexValue[]>({
    queryKey: queryKeys.indexes(),
    queryFn: () => getIndexes(bearerToken),
    enabled: enabled && !!bearerToken,
  });
};
